import { IApplicationState } from '../../types/redux';

export const selectIsModalRenameOpen = (state: IApplicationState) => state.folders.modalRenameIsOpen;
